// AccountDetailsContext.js
import React, { createContext, useContext } from 'react';

const AccountDetailsContext = createContext(null);

export const useAccountDetails = () => useContext(AccountDetailsContext);

export const AccountDetailsProvider = ({ accountDetails, children }) => (
  <AccountDetailsContext.Provider value={accountDetails}>
    {children}
  </AccountDetailsContext.Provider>
);
